import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { filter, map, switchMap, take } from "rxjs";
import { InteractionStatus } from "@azure/msal-browser";
import { MsalBroadcastService, MsalService } from "@azure/msal-angular";
import { AuthenticationActions } from "./authentication.actions";
import { UserActions } from "../../user/user.actions";

@Injectable()
export class AuthenticationEffects {
    private readonly actions$ = inject(Actions);
    private readonly authService = inject(MsalService);
    private readonly msalBroadcastService = inject(MsalBroadcastService);

    initializeMsalAuthentication$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AuthenticationActions.initializeAuthentication),
            switchMap(() =>
                this.msalBroadcastService.inProgress$.pipe(
                    filter((status: InteractionStatus) => status === InteractionStatus.None),
                    take(1),
                    map(() => {
                        let account = this.authService.instance.getActiveAccount();
                        const accounts = this.authService.instance.getAllAccounts();
                        if (!account && accounts.length > 0) {
                            account = accounts[0];
                            this.authService.instance.setActiveAccount(account);
                        }
                        if (account) {
                            return AuthenticationActions.initializeAuthenticationSuccess({ account, isAuthenticated: true });
                        } else {
                            return AuthenticationActions.initializeAuthenticationFailure({
                                error: { message: "No active account found" },
                                isAuthenticated: false,
                            });
                        }
                    }),
                ),
            ),
        ),
    );

    initializeAuthenticationSuccess$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AuthenticationActions.initializeAuthenticationSuccess),
            map(({ account }) => UserActions.initializeUser({ account })),
        ),
    );
}
